import { useEffect, useState } from "react";
import CustomButton from "../../UI/Buttons/CustomButton";
import CheckFilled from "../../UI/Icons/CheckFilled";
import LeftArrow from "../../UI/Icons/LeftArrow";
import RightArrow from "../../UI/Icons/RightArrow";
import SearchListings from "../../UI/Icons/SearchListings";
import { useNavigate } from "react-router";
import { AUTH_ROUTE } from "../../../pages/App/routes";

type CardItem = {
  id: number;
  title: string;
  centre: string;
  time: string;
};

const items: CardItem[] = [
  {
    id: 1,
    title: "Early Childhood 1",
    centre: "Bravo Charlie Centre, Farfette South",
    time: "Today, now until 5:30pm",
  },
  {
    id: 2,
    title: "Early Childhood 2",
    centre: "Bravo Charlie Centre, Farfette South",
    time: "Today, now until 5:30pm",
  },
  {
    id: 3,
    title: "Early Childhood 3",
    centre: "Bravo Charlie Centre, Farfette South",
    time: "Today, now until 5:30pm",
  },
  {
    id: 4,
    title: "Early Childhood 4",
    centre: "Bravo Charlie Centre, Farfette South",
    time: "Today, now until 5:30pm",
  },
  {
    id: 5,
    title: "Early Childhood 5",
    centre: "Bravo Charlie Centre, Farfette South",
    time: "Today, now until 5:30pm",
  },
  {
    id: 6,
    title: "Early Childhood 6",
    centre: "Bravo Charlie Centre, Farfette South",
    time: "Today, now until 5:30pm",
  },
];

const UrgentVacanciesPanel = ({
  urgent_vacancies,
}: {
  urgent_vacancies: number;
}) => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const maxIndex = items.length - itemsPerPage;
  const visibleItems = items.slice(currentIndex, currentIndex + itemsPerPage);

  // Update itemsPerPage based on screen width
  useEffect(() => {
    const updateItemsPerPage = () => {
      const width = window.innerWidth;
      const newItemsPerPage = width <= 992 ? 1 : 3;

      setItemsPerPage((prev) => {
        // Only update if changed
        if (prev !== newItemsPerPage) {
          setCurrentIndex(0); // Optional: reset index when layout changes
          return newItemsPerPage;
        }
        return prev;
      });
    };

    updateItemsPerPage(); // Initial check
    window.addEventListener("resize", updateItemsPerPage);

    return () => {
      window.removeEventListener("resize", updateItemsPerPage);
    };
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => Math.min(prev + 1, maxIndex));
  };

  const handleViewClick = () => {
    navigate(AUTH_ROUTE.ADMIN_URGENT_VACANCIES);
  };

  return (
    <>
      {urgent_vacancies === 0 ? (
        <div className="d-flex gap-3 align-items-center">
          <CheckFilled />
          <div className="fs-16 fw-400 text-black">
            <span className="fw-700">All Urgent Vacancies</span> have been
            filled!
          </div>
        </div>
      ) : (
        <div className="border border-grey-light radius-8px p-10px d-flex flex-column gap-10">
          {/* Header */}
          <div className="d-flex flex-column flex-lg-row gap-3 gap-mobile-20 align-items-lg-center justify-content-lg-between">
            <div className="d-flex gap-3 align-items-center">
              <SearchListings />
              <div className="w-15px"></div>
              <div className="d-flex flex-column flex-lg-row gap-3 align-items-lg-center">
                <div className="fs-45 fw-400 text-black">
                  {urgent_vacancies}
                </div>
                <div className="w-5px" />
                <div className="d-flex flex-column gap-3">
                  <div className="fs-16 fw-700 text-black">
                    Urgent Vacancies
                  </div>
                  <div className="fs-16 fw-400 text-grey-dark">
                    Required within the next 24 hours
                  </div>
                </div>
              </div>
            </div>
            <CustomButton
              variant={"primary"}
              type="button"
              className="btn-theme bg-off-white text-black max-h-30px"
              onClick={handleViewClick}
            >
              View
            </CustomButton>
          </div>
        </div>
      )}
    </>
  );
};

export default UrgentVacanciesPanel;
